import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const PositionSizeAndRiskManagementPage = () => {
  return (
    <div className="bg-[#0b0d2a] text-white font-sans">
      {/* Hero Section */}
      <HeadersNonAuth />
      <br />
      <br />
      <div
        className="h-[300px] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/headers-landing.png')" }}
      >
        <h1 className="text-white text-4xl sm:text-5xl font-bold">
          Position Size and Risk Management
        </h1>
      </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto py-12 px-6 space-y-6">
        <p>
          New traders often ask how they can manage risk by structuring their trades based on a certain percentage of their account balance. JTNC suggests traders should aim to risk between <strong>2.5% to 5%</strong> of their account balance per trade. That said, smaller traders may need to increase this to <strong>10%</strong> of their account balance. If you are a small trader with an account size of $2000 or less, and are subscribed to either JTNC service, JTNC recommends you take only one trade at a time and keep your total risk to no more than 10% of your account balance. With proper scaling, even a small account can potentially grow into a much larger account. When your account size reaches $5000 or more, JTNC suggests you follow the 2.5% to 5% risk target per trade.
        </p>

        <h2 className="text-2xl font-semibold mt-8">Example</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Expiry:</strong> 27Oct23</li>
          <li><strong>Buy:</strong> 413 Call</li>
          <li><strong>Price:</strong> $1.60 or better</li>
          <li><strong>Recommended Size:</strong> 1</li>
          <li><strong>Target Exit:</strong> $415 SPY/$2.25</li>
        </ul>

        <p>
          This is an actual trade from October 26, 2023. JTNC sizing recommendations are based on a $5000 account size. If you had a $10,000 account, you would trade 2 options. Given options quotes represent 100 shares of the underlying security, the purchase of a Call option on SPY for $1.60 will actually risk $160 plus commissions. For a $5000 account, the percent risk is computed as follows:
        </p>

        <p><strong>$160/$5000 = 3.2%</strong></p>

        <p>
          This is well within the target 2.5% to 5% range JTNC recommends. Given this is a risk per <em>trade</em> should you subscribe to both JTNC services, you can still take a second trade risking @ the same amount and be within your risk rules.
        </p>

        <h2 className="text-2xl font-semibold mt-8">Why is Sizing Important</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>Position sizing is crucial for risk management in options trading.</li>
          <li>Traders should structure their risk based on a percentage of their account balance.</li>
          <li>On average, risking 2.5% to 5% of the account balance per trade is recommended.</li>
          <li>Thinking in terms of percentages allows for effective scaling and growth of the trading account.</li>
          <li>The math involved in calculating these percentages is relatively straightforward.</li>
          <li>Position sizing is an essential aspect of risk management in trading. It involves determining the amount of capital to allocate to a particular trade based on a percentage of the total trading account.</li>
          <li><strong>Max Loss:</strong> The maximum loss on any trade should not exceed the predetermined risk percentage.</li>
        </ul>
      </div>
    </div>
  );
};

export default PositionSizeAndRiskManagementPage;
